import React from 'react';
import { Link, To } from 'react-router-dom';

import { useMenuContext } from './context';

export type Props = {
  to?: To | undefined;
  itemKey: string | number;
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
  id?: string;
};

const Item: React.FC<Props> = (props) => {
  const menuProps = useMenuContext();
  const { isActive, itemKey, children, to, className, id, onClick } = props;
  const { activeKeys = [] } = menuProps;

  const getCls = () => {
    const activeCls = isActive || activeKeys?.includes(itemKey) ? 'active' : '';

    return ['item', activeCls, className].filter(Boolean).join(' ');
  };

  return (
    <div className={getCls()} id={id}>
      {to ? (
        <Link to={to!}>{children}</Link>
      ) : (
        <span onClick={onClick}>{children}</span>
      )}
    </div>
  );
};

export default Item;
